// returns 1-7 where 1 is Monday, 2 is Tues, 3 - Wed, 4 - Thu, 5 - Fri, 6 - Sat and 7 is Sunday

export const Doctors = [
  {
    id: "pui63u2n6YriQB5LaE4a",
    displayName: "Jayaprakash",
    email: "jayaprakash@medoc.life",
    mobile: "+918484953095",
    availableDays: [1, 2, 3, 4, 5, 6, 7],
  },
  {
    id: "HXi6OfsaYwx26yyc0bXA",
    displayName: "Clinton",
    email: "clinton@medoc.life",
    mobile: "+919591727721",
    availableDays: [],
  },
];
